module.exports = "/packs/images/products/collections/2-560facc90ee49f944299ae0dc3be86f1.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/collections/2.png
// module id = 1805
// module chunks = 0